import PropTypes from "prop-types";
import styled from "styled-components";

import { Button } from "@/components";

const formatDate = (isoDate) => {
    if (!isoDate) {
        return "Never";
    }

    let dateStr = isoDate;

    if (!dateStr.endsWith("Z")) {
        dateStr += "Z";
    }

    return new Date(dateStr).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
};

const FormFooter = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0.5em;
`;

const FooterInfo = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 0.85em;
    color: #666;
`;

const FooterActions = styled.div`
    display: flex;
    gap: 0.75em;
`;

/**
 * Settings modal footer with Close, Save, and Save & Publish buttons plus last-saved/published dates.
 *
 * @param root0 - The component props.
 * @param root0.settings - The current group settings.
 * @param root0.onClose - The close event handler.
 * @param root0.onSave - The save event handler.
 * @param root0.onSaveAndPublish - The save and publish event handler.
 * @param root0.canSave - Whether saving is allowed.
 * @returns The rendered footer.
 */
const Footer = ({
    settings,
    onClose,
    onSave,
    onSaveAndPublish,
    canSave = true,
}) => (
    <FormFooter>
        <FooterInfo>
            <div>Last Saved: {formatDate(settings.lastUpdateDate)}</div>
            <div>Last Published: {formatDate(settings.lastPublishedDate)}</div>
        </FooterInfo>
        <FooterActions>
            <Button type="button" outlined onClick={onClose}>
                Close
            </Button>
            <Button type="button" disabled={!canSave} onClick={onSave}>
                Save
            </Button>
            <Button
                type="button"
                disabled={!canSave}
                onClick={onSaveAndPublish}
            >
                Save & Publish
            </Button>
        </FooterActions>
    </FormFooter>
);

Footer.propTypes = {
    settings: PropTypes.object,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    onSaveAndPublish: PropTypes.func,
    canSave: PropTypes.bool,
};

export default Footer;
